import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GlobalState {
    isLoading: boolean;
    menuOpen: boolean;
    openIdCallbackUrl?: string;
}

const INITIAL_STATE: GlobalState = {
    isLoading: false,
    menuOpen: false
};

export const globalSlice = createSlice({
    name: 'global',
    initialState: INITIAL_STATE,
    reducers: {
        setLoading: (state: GlobalState, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isLoading: action.payload
            };
        },
        showMenu: (state: GlobalState, action: PayloadAction<boolean>) => {
            return {
                ...state,
                menuOpen: action.payload
            };
        },
        setOpenIdCallBackUrl: (state: GlobalState, action: PayloadAction<string>) => {
            return {
                ...state,
                openIdCallbackUrl: action.payload
            };
        },

    }
});

export const {setLoading, showMenu, setOpenIdCallBackUrl} = globalSlice.actions;
